import ActionType from './actionType';

export const setCompany = (company, project) => ({
  type: ActionType.SET_COMPANY,
  payload: { company: company, project: project },
});
